
import { Component } from "@angular/core";
import { SharedModule } from "@shared/shared.module";

@Component({
  selector: "app-back-ground-theme, [app-back-ground-theme]",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./back-ground-theme.component.html",
  styleUrl: "./back-ground-theme.component.scss",
})
export class BackGroundThemeComponent {}
